var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66734 18.6628H13.334C16.684 18.6628 17.284 17.3211 17.459 15.6878L18.084 9.02109C18.309 6.98776 17.7257 5.32943 14.1673 5.32943H5.834C2.27567 5.32943 1.69234 6.98776 1.91734 9.02109L2.54234 15.6878C2.71734 17.3211 3.31734 18.6628 6.66734 18.6628Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66734 5.32943V4.66276C6.66734 3.18776 6.66734 1.99609 9.334 1.99609H10.6673C13.334 1.99609 13.334 3.18776 13.334 4.66276V5.32943",
    fill: "white",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 11.1628V11.9961C11.6673 12.0044 11.6673 12.0044 11.6673 12.0128C11.6673 12.9211 11.659 13.6628 10.0007 13.6628C8.35067 13.6628 8.334 12.9294 8.334 12.0211V11.1628C8.334 10.3294 8.334 10.3294 9.16734 10.3294H10.834C11.6673 10.3294 11.6673 10.3294 11.6673 11.1628Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0423 9.49609C16.1173 10.8961 13.9173 11.7294 11.6673 12.0128L18.0423 9.49609Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.184 9.72109C4.059 11.0044 6.17567 11.7794 8.334 12.0211L2.184 9.72109Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66734 5.32943V4.66276C6.66734 3.18776 6.66734 1.99609 9.334 1.99609H10.6673C13.334 1.99609 13.334 3.18776 13.334 4.66276V5.32943M11.6673 12.0128C11.6673 12.0044 11.6673 12.0044 11.6673 11.9961V11.1628C11.6673 10.3294 11.6673 10.3294 10.834 10.3294H9.16734C8.334 10.3294 8.334 10.3294 8.334 11.1628V12.0211M11.6673 12.0128C11.6673 12.9211 11.659 13.6628 10.0007 13.6628C8.35067 13.6628 8.334 12.9294 8.334 12.0211M11.6673 12.0128C13.9173 11.7294 16.1173 10.8961 18.0423 9.49609M8.334 12.0211C6.17567 11.7794 4.059 11.0044 2.184 9.72109M6.66734 18.6628H13.334C16.684 18.6628 17.284 17.3211 17.459 15.6878L18.084 9.02109C18.309 6.98776 17.7257 5.32943 14.1673 5.32943H5.834C2.27567 5.32943 1.69234 6.98776 1.91734 9.02109L2.54234 15.6878C2.71734 17.3211 3.31734 18.6628 6.66734 18.6628Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.c415487be5e556312c1f8dd1b39618d4.svg";
export { ForwardRef as ReactComponent };